import { render, staticRenderFns } from "./ProjectHome.vue?vue&type=template&id=4b4fe964&"
import script from "./ProjectHome.vue?vue&type=script&lang=js&"
export * from "./ProjectHome.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4fe964')) {
      api.createRecord('4b4fe964', component.options)
    } else {
      api.reload('4b4fe964', component.options)
    }
    module.hot.accept("./ProjectHome.vue?vue&type=template&id=4b4fe964&", function () {
      api.rerender('4b4fe964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProjectHome.vue"
export default component.exports